import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import { TextField } from './TextField';
import QuestionnaireContext from '../QuestionnaireContext';

const useToggleButtonGroupStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  grouped: {
    padding: 25,
    '&:not(:first-child), &:not(:last-child)': {
      marginLeft: 'inherit',
      borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
    },
  },
}));
const useToggleButtonStyle = makeStyles({
  root: {
    minHeight: 100,
    flex: '0 0 200px',
    margin: 25,
  },
});

const ButtonsWithOther = ({ options, questionId, onChange, handleValidation }) => {
  const { t } = useTranslation();
  const { setParam } = useContext(QuestionnaireContext);
  const [currentValue, setCurrentValue] = useState();
  const [otherValue, setOtherValue] = useState('');
  const [type, setType] = useState();
  const toggleButtonGroupClasses = useToggleButtonGroupStyles();
  const toggleButtonClasses = useToggleButtonStyle();

  const setValidate = value => {
    if (handleValidation) {
      setParam('isValidate', value);
    }
  };

  const handleChange = (event, answerId) => {
    if (answerId === null) {
      return;
    }
    const option = options.find(item => item.answerId === answerId);

    setCurrentValue(answerId);
    setType(option.type);

    if (option.type === 'text') {
      onChange(questionId, {
        answer: '',
        other: true,
      });
      setValidate(false);
      return;
    }

    onChange(questionId, {
      answer: option.answerId,
    });
    setValidate(true);
  };
  const handleOtherChange = event => {
    const { value } = event.target;

    setOtherValue(value);
    onChange(questionId, {
      answer: value,
      other: true,
    });

    if (value.length) {
      setValidate(true);
    } else {
      setValidate(false);
    }
  };

  return (
    <>
      <div>
        <ToggleButtonGroup
          onChange={handleChange}
          value={currentValue}
          classes={toggleButtonGroupClasses}
          exclusive
        >
          {options.map(({ answerLabel, answerId }) => (
            <ToggleButton key={answerId} value={answerId} classes={toggleButtonClasses}>
              {answerLabel}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </div>
      {type === 'text' && (
        <TextField
          label={options.find(item => item.answerId === currentValue).answerLabel}
          onChange={handleOtherChange}
          value={otherValue}
          placeholder={t('Enter text')}
          fullWidth
        />
      )}
    </>
  );
};

ButtonsWithOther.defaultProps = {
  handleValidation: true,
};

ButtonsWithOther.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      answerId: PropTypes.number.isRequired,
      answerLabel: PropTypes.string.isRequired,
      answerName: PropTypes.string.isRequired,
      type: PropTypes.string,
    }),
  ).isRequired,
  questionId: PropTypes.number.isRequired,
  handleValidation: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export { ButtonsWithOther };
